/* Verificar cores
https://bareynol.github.io/mui-theme-creator/
*/

import { createTheme } from "@mui/material"
export const LightTheme = createTheme({
    palette: {
        // primary: {
        //     main: yellow[700],
        //     light: yellow[500],
        //     dark: yellow[900],
        //     contrastText: '#FFFFFF'
        // },
        one_primary: {
            main: '#8A05BE',
            light: '#A137CB',
            dark: '#600385',
            contrastText: '#FFFFFF'
        },
        one_secondary: {
            main: '#FFFFFF',
            light: '#FFFFFF',
            dark: '#600385',
            contrastText: 'rgba(0, 0, 0, 0.87)'
        },
        one_secondary_light: {
            main: '#FFFFFF',
            light: '#FFFFFF',
            dark: '#aeaeae',
            contrastText: 'rgba(0, 0, 0, 0.87)'
        },
        one_disabled: {
            main: '#D9D9D9',
            light: '#FFFFFF',
            dark: '#600385',
            contrastText: 'rgba(0, 0, 0, 0.87)'
        },
        one_bar_gradient: 'linear-gradient(90deg, #590CFB 0%, #9500C8 83%)',
        one_modal_backcolor: '#D9D9D9',
        card_event_dark: '#837D88',
        card_event_light: '#A8A4AB',
        on: '#5DFF5D',
        off: 'red'
    },
    typography: {
        allVariants: {
            fontFamily: 'Montserrat, sans-serif',
            color: '#000000'
        }
    }
})
